import * as React from 'react';
import { observer } from 'mobx-react-lite';

export const ModalMessageAgreement: React.FC<any> = observer(
	() =>
	{
		return (
			<div className="modal-content">
				<p>
					Использование настоящего интерактивного сервиса подразумевает создание в электронной форме
					заявления для внесения изменений в Реестр операторов электронного документооборота (далее − Оператор ЭДО).
					В заявлении могут содержаться персональные данные, которые будут переданы на сервер Федеральной налоговой службы
					для их дальнейшего отражения в электронной форме заявления. Эти данные могут быть переданы также организациям,
					подведомственным ФНС России, и организациям, привлекаемым ФНС России на контрактной основе,
					для последующей обработки данных в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».
				</p>
				<p>
					Даю свое согласие на обработку персональных данных, то есть на совершение действий,
					предусмотренных пунктом 3 статьи 3 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных»,
					в том числе с использованием услуг иного лица на основании заключаемого ФНС России с этим лицом договора,
					в том числе государственного контракта, либо путем принятия соответствующего нормативного правового акта.
				</p>
				<p>
					Гарантирую, что при создании заявления для внесения изменений в Реестр операторов ЭДО
					не нарушается действующее законодательство Российской Федерации,
					законные права и интересы третьих лиц.
				</p>
				<p>
					Настоящее согласие действует не более срока, необходимого для создания в электронной форме заявления
					для добавления или уточнения сведений в Реестре операторов ЭДО и достижения цели обработки персональных данных,
					если иное не предусмотрено законодательством Российской Федерации.
				</p>
				<p>
					Я даю согласие на обработку персональных данных.
				</p>
			</div>
		);
	}
)
